import React from 'react';

import Style from './previewEmpty.module.css';

export function PreviewEmpty({ icon = null, title = null, className = null }) {
    return (
        <div className={`${Style['preview-empty']}${className ? ` ${className}` : ''}`}>
            {icon && <span className={Style['preview-empty__icon']}>{icon}</span>}
            {title && <span className={Style['preview-empty__title']}>{title}</span>}
        </div>
    );
}
